import React from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

const Layout = ({ children }) => (
  <div style={styles.root}>
    <Navbar />
    <div style={styles.body}>
      <Sidebar />
      <div style={styles.contentArea}>
        <main style={styles.main}>{children}</main>
        <Footer />
      </div>
    </div>
  </div>
);

const styles = {
  root: { display: "flex", flexDirection: "column", minHeight: "100vh" },
  body: { display: "flex", flex: 1 },
  contentArea: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: "calc(100vh - 56px)",
  },
  main: {
    flex: 1,
    padding: 28,
    background: "#f8f9fb",
    overflowY: "auto",
  },
};

export default Layout;
